import React from 'react';
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, } from '@cargomatic/ui';
import { ChevronDown } from 'lucide-react';
import { FilterDateRange } from '../molecules/FilterDateRange';
/**
 * Shared date range filter organism.
 * Wrap with FilterGroup at the page level.
 */
export function DateRangeFilter({ value, onChange }) {
    return React.createElement(FilterDateRange, { value: value, onChange: onChange });
}
export function DateRangeWithTypeFilter({ typeOptions, value, onChange, }) {
    var _a, _b, _c;
    const selectedLabel = ((_a = typeOptions.find((o) => o.value === value.type)) === null || _a === void 0 ? void 0 : _a.label) ||
        ((_b = typeOptions[0]) === null || _b === void 0 ? void 0 : _b.label) ||
        '';
    return (React.createElement("div", { className: "space-y-2" },
        React.createElement(DropdownMenu, null,
            React.createElement(DropdownMenuTrigger, { asChild: true },
                React.createElement(Button, { variant: "outline", size: "sm", className: "w-full justify-between font-normal h-8" },
                    React.createElement("span", null, selectedLabel),
                    React.createElement(ChevronDown, { className: "size-3 opacity-50" }))),
            React.createElement(DropdownMenuContent, { align: "start", style: { minWidth: 'var(--radix-dropdown-menu-trigger-width)' } }, typeOptions.map((opt) => (React.createElement(DropdownMenuItem, { key: opt.value, onClick: () => onChange(Object.assign(Object.assign({}, value), { type: opt.value })) }, opt.label))))),
        React.createElement(FilterDateRange, { value: value.from
                ? { from: value.from, to: (_c = value.to) !== null && _c !== void 0 ? _c : undefined }
                : undefined, onChange: (range) => {
                var _a, _b;
                return onChange(Object.assign(Object.assign({}, value), { from: (_a = range === null || range === void 0 ? void 0 : range.from) !== null && _a !== void 0 ? _a : null, to: (_b = range === null || range === void 0 ? void 0 : range.to) !== null && _b !== void 0 ? _b : null }));
            } })));
}
